export default "__VITE_ASSET__C6$vz9yN__"